export default "__VITE_ASSET__BWg2fpoD__"